/* ==========================================================================
   NADEL ACADEMY — bundle JS unico
   Un solo file per tutto il sito: navigazione, reveal, FAQ, switch scuola,
   timeline, reel e flusso lead Open Day (Sheet + WhatsApp + pixel Meta).
   Nessuno script duplicato per-sezione.
   ========================================================================== */
(function () {
  if (window.__nadelInit) return;
  window.__nadelInit = true;
  'use strict';

  /* ---------- Config lead flow (contesto/lead-flow-whatsapp.md) ---------- */
  var ENDPOINT = 'https://script.google.com/macros/s/AKfycbzQl3ND5KpFi6iNzPZrYWJLP1dowgOcPhCmenNsycLFqaaCOEyqeDVGVXei8TsLsco1/exec';
  var WA_NUMBER = '393246132172';

  /* ---------- Utility ---------- */
  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }
  function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.n-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Drawer mobile: chiudi al click su un link ---------- */
  function initDrawer() {
    document.querySelectorAll('.n-nav__drawer').forEach(function (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { drawer.removeAttribute('open'); });
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    document.querySelectorAll('.n-faq__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.n-faq__item');
        var content = item.querySelector('.n-faq__content');
        var isOpen = item.classList.contains('is-open');
        if (isOpen) {
          content.style.maxHeight = null;
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Switch scuola (Parrucchieri / Estetica) ----------
     Ogni .n-switch[data-switch="scuola"] è sincronizzato con:
     - le timeline [data-timeline="parrucchieri|estetica"]
     - il campo nascosto input[name="scuola"] di ogni form lead
     - gli altri switch della pagina (stessa scelta ovunque)          */
  var currentScuola = 'parrucchieri';

  function setScuola(value) {
    currentScuola = value;
    document.querySelectorAll('.n-switch[data-switch="scuola"] .n-switch__btn').forEach(function (btn) {
      var active = btn.getAttribute('data-value') === value;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-timeline]').forEach(function (list) {
      list.classList.toggle('is-active', list.getAttribute('data-timeline') === value);
    });
    document.querySelectorAll('form[data-lead-form] input[name="scuola"]').forEach(function (input) {
      input.value = value;
    });
  }

  function initScuolaSwitch() {
    document.querySelectorAll('.n-switch[data-switch="scuola"] .n-switch__btn').forEach(function (btn) {
      btn.addEventListener('click', function () { setScuola(btn.getAttribute('data-value')); });
    });
    setScuola(currentScuola);
  }

  /* ---------- Reel play/pause ---------- */
  function initReels() {
    document.querySelectorAll('.n-reel__play').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = btn.closest('.n-reel, .n-video').querySelector('video');
        if (!video) return;
        if (video.paused) {
          video.play();
          btn.classList.add('is-playing');
          btn.setAttribute('aria-label', 'Metti in pausa il video');
        } else {
          video.pause();
          btn.classList.remove('is-playing');
          btn.setAttribute('aria-label', 'Riproduci il video');
        }
      });
    });
  }

  /* ---------- Flusso lead Open Day ----------
     Regola non negoziabile: MAI perdere il lead. Lo Sheet riceve i dati via
     sendBeacon (non bloccante); WhatsApp si apre comunque, anche se lo
     Sheet fallisce. Validazione + consenso GDPR prima dell'invio.        */
  function handleLeadSubmit(form) {
    var errorBox = form.querySelector('.n-form__error');
    var showError = function (msg) {
      if (errorBox) {
        errorBox.textContent = msg;
        errorBox.classList.add('is-visible');
      }
    };
    if (errorBox) errorBox.classList.remove('is-visible');

    var name = (form.querySelector('[name="name"]') || {}).value || '';
    var phone = (form.querySelector('[name="phone"]') || {}).value || '';
    var target = (form.querySelector('[name="target"]') || {}).value || '';
    var city = (form.querySelector('[name="city"]') || {}).value || '';
    var scuola = (form.querySelector('[name="scuola"]') || {}).value || currentScuola;
    var consentEl = form.querySelector('[name="consent"]');
    var consent = consentEl ? consentEl.checked : false;

    name = name.trim(); phone = phone.trim(); city = city.trim();

    // Validazione campi obbligatori
    if (!name || !phone || !target || !city) {
      showError('Compila tutti i campi per continuare.');
      return;
    }
    if (!consent) {
      showError('Accetta la privacy policy per continuare.');
      return;
    }

    // Payload — stessi campi del meccanismo esistente + scuola
    var eventId = uuid();
    var now = new Date().toISOString();
    var payload = {
      timestamp: now,
      source: form.getAttribute('data-lead-source') || 'cta-open-day',
      name: name,
      phone: phone,
      target: target,
      city: city,
      scuola: scuola,
      consent: 'sì — ' + now,
      status: 'nuovo',
      event_id: eventId,
      fbclid: getParam('fbclid'),
      fbp: getCookie('_fbp'),
      fbc: getCookie('_fbc'),
      utm_source: getParam('utm_source'),
      utm_medium: getParam('utm_medium'),
      utm_campaign: getParam('utm_campaign'),
      page_url: window.location.href,
      ua: navigator.userAgent
    };

    // 1. Sheet in background — non blocca WhatsApp
    try {
      var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=utf-8' });
      navigator.sendBeacon(ENDPOINT, blob);
    } catch (e) { /* il lead prosegue comunque verso WhatsApp */ }

    // 2. Bus Shopify — per il custom pixel Meta (evento Lead)
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish('nadel_lead_submitted', payload);
    }

    // 3. Apri WhatsApp — istantaneo
    var targetLabel = target === 'per-me' ? 'per me' : 'per mia figlia';
    var scuolaLabel = scuola === 'estetica' ? 'Estetica' : 'Parrucchieri';
    var msg = encodeURIComponent(
      'Ciao! Sono ' + name + ' (' + city + '). ' +
      "Vorrei prenotare l'Open Day gratuito di Nadel Accademia — scuola " +
      scuolaLabel + ' (' + targetLabel + '). ' +
      'Il mio numero è ' + phone + '.'
    );
    window.open('https://wa.me/' + WA_NUMBER + '?text=' + msg, '_blank');
  }

  function initLeadForms() {
    document.querySelectorAll('form[data-lead-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        handleLeadSubmit(form);
      });
    });
  }

  /* ---------- Avvio ---------- */
  function init() {
    initReveal();
    initDrawer();
    initFaq();
    initScuolaSwitch();
    initReels();
    initLeadForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
